import { useState, useEffect, useCallback } from "react";
import { makeApiRequest, apiRoutes } from "constants/apiRoutes";
import { useAuth } from "utilities/auth";

export function useInvitations(overrideCompanyId) {
  const [invitations, setInvitations] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  const { user } = useAuth();

  const companyId = overrideCompanyId || user?.companyId;

  const fetchInvitations = useCallback(async () => {
    if (!companyId) return;
    setLoading(true);
    setError(null);

    try {
      const res = await makeApiRequest(
        "get",
        apiRoutes.getInvitations,
        { id: user.id, accessToken: user.accessToken },
        companyId
      );
      setInvitations(res.data?.data ?? res.data ?? []);
    } catch (err) {
      setError(err);
    } finally {
      setLoading(false);
    }
  }, [companyId, user?.id, user?.accessToken]);

  useEffect(() => {
    fetchInvitations();
  }, [fetchInvitations]);

  return { invitations, loading, error, refetch: fetchInvitations };
}
